export class ObjectHolder<T> {

    constructor(public value: T) {

    }

}